import EfishDataService from '@/services/EfishDataService'
import moment from 'moment'

const LiveReportService = {
  /**
   * Gets the location detail summary. The data is mutated after
   * being recieved to set a "needed" on the clocked in records based
   * on the scheduled (goals) data by job code.
   * Data points:
   * shift: sales by shift for the day
   * schedule: pulled from schedule goals, tries to identify employees needed
   * sales: sales data for the last hour
   * labor: totals of labor for the day
   * lasthour: whether we reiceved data in the past hour
   * clocked: people currenlty clocked in labor
   * timeoff: people who have timeoff requests for current day
   * {"location":{"shifts":{"71":{"shift_id":71,"shift_name":"LUNCH","shift_location":3,"shift_start":"04:01:00","shift_end":"14:59:59","shift_length":"10:58:59"},"81":{"shift_id":81,"shift_name":"HAPPY HR","shift_location":3,"shift_start":"15:00:00","shift_end":"18:59:59","shift_length":"03:59:59"},"91":{"shift_id":91,"shift_name":"DINNER","shift_location":3,"shift_start":"19:00:00","shift_end":"21:59:59","shift_length":"02:59:59"},"101":{"shift_id":101,"shift_name":"LATE NT","shift_location":3,"shift_start":"22:00:00","shift_end":"04:00:00","shift_length":"-18:00:00"}},"schedule":{"171":{"job_id":171,"location_id":3,"formulavalue":1,"formulametric":1100,"functionname":"salesPerHour","job":"Bartender"},"181":{"job_id":181,"location_id":3,"formulavalue":1,"formulametric":1000,"functionname":"salesPerHour","job":"Cook"}},"sales":{"location_id":3,"net":356.19,"discount":28,"gross":384.19,"tax":40.56,"totalcheckcount":14,"opencheckcount":13,"guestcount":14,"guestcurrent":13},"labor":{"location_id":3,"hours":14.56,"laborcost":177.49,"employees":5,"clocked_in":5},"lasthour":false,"clocked":{"171":{"name":"Bartender","count":1},"181":{"name":"Cook","count":2},"191":{"name":"Dish","count":1},"402":{"name":"Ghost Bartender","count":1}},"updated":{"location_id":3,"businessdate":"2019-11-13","lastupdate":"2019-11-13 14:05:05"},"lastupdate":1573679105000,"name":"El Hefe Chicago","id":3}}
   * @param {int|string} locationId
   */
  getLocation (locationId) {
    return EfishDataService.getData(`api/v1/report/live/location/${locationId}`, null, 'get', moment().add(5, 'Minutes').toDate())
      .then(x => {
        const data = x.location
        this.reportModuleSetLocationGoalData(data)
        return data
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },

  getLocationSummary (locationId) {
    return EfishDataService.getData(`api/v1/report/live/location/${locationId}/summary`, null, 'get', moment().add(5, 'Minutes').toDate())
      .then(x => {
        const data = x.summary

        if (Object.prototype.hasOwnProperty.call(data, 'sales')) {
          this.reportModuleSetLocationGoalData(data)
        }

        return data
      }).catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] LiveReportService ${error}`)
      })
  },
  locationHistoricData (location) {
    const now = moment()
    const reset = moment()
    if (now.hour() > parseInt(location.daystart.substr(0, 2))) {
      // set reset (get data again) to the day start of this location tomorrow
      reset.add(1, 'Day')
      reset.hour(parseInt(location.daystart.substr(0, 2)))
    } else {
      // otherwise we are in that same day (12AM - 3AM typically), set it to the day start of this same day
      reset.hour(parseInt(location.daystart.substr(0, 2)))
    }

    return EfishDataService.getData(`api/v1/report/live/location/${location.id}/historic`, null, 'get', reset.toDate())
      .then(x => {
        return x
      }).catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] LiveReportService ${error}`)
      })
  },
  /**
   * Basically just gets the items sold today, then
   * mutates the data to create arrays by shift/employee/items
   * @param {int} locationId
   */
  getLocationSales (locationId) {
    return EfishDataService.getData(`api/v1/report/live/location/${locationId}/sales`, null, 'get', moment().add(5, 'Minutes').toDate())
      .then(data => {
        var byItem = {}
        var byEmployee = {}
        var byShift = {}
        data.sales.forEach(function (sale) {
          if (sale.voided === 1 || sale.item_voided === 1) {
            // Skip voided checks and voided items
            return
          }
          if (byItem[sale.item_name] !== undefined) {
            byItem[sale.item_name].quantity += Number(sale.item_quantity)
            byItem[sale.item_name].total += parseFloat(sale.item_amount)
          } else {
            byItem[sale.item_name] = {
              quantity: Number(sale.item_quantity),
              total: parseFloat(sale.item_amount),
              item: sale.item_name,
              item_id: sale.item_id
            }
          }
          if (byEmployee[sale.employee] === undefined) {
            byEmployee[sale.employee] = {
              tickets: {},
              total: Number(0),
              count: Number(0),
              employee: sale.employee,
              employee_id: sale.employee_id
            }
          }
          if (byEmployee[sale.employee].tickets[sale.id] === undefined) {
            byEmployee[sale.employee].total += parseFloat(sale.total)
            byEmployee[sale.employee].count++
            byEmployee[sale.employee].tickets[sale.id] = sale.total
          }
          if (byShift[sale.shift] === undefined) {
            byShift[sale.shift] = {
              tickets: {},
              total: Number(0),
              count: Number(0),
              guests: Number(0),
              shift: sale.shift,
              time: sale.opentime
            }
          }
          if (byShift[sale.shift].tickets[sale.id] === undefined) {
            byShift[sale.shift].total += parseFloat(sale.total)
            byShift[sale.shift].count++
            byShift[sale.shift].guests += sale.guestcount
            byShift[sale.shift].tickets[sale.id] = sale.total
          }
        })
        /* converting objects back to arrays for angular ordering */
        var items = []
        let key = null
        for (key in byItem) {
          if (Object.prototype.hasOwnProperty.call(byItem, key)) {
            items.push(byItem[key])
          }
        }
        var employees = []
        for (key in byEmployee) {
          if (Object.prototype.hasOwnProperty.call(byEmployee, key)) {
            employees.push(byEmployee[key])
          }
        }
        var shifts = []
        for (key in byShift) {
          if (Object.prototype.hasOwnProperty.call(byShift, key)) {
            shifts.push(byShift[key])
          }
        }
        data.sales = {
          items: items,
          employees: employees,
          shifts: shifts
        }
        return data
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getEmployeeSummary (locationId) {
    return EfishDataService.getData(`api/v1/report/live/location/${locationId}/employeesales`, null, 'get', moment().add(5, 'Minutes').toDate())
      .then(data => {
        return data
      }).catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] LiveReportService ${error}`)
      })
  },
  getItemTracking (locationId) {
    return EfishDataService.getData(`api/v1/report/live/location/${locationId}/itemtracking`, null, 'get', moment().add(5, 'Minutes').toDate())
      .then(data => {
        return data
      }).catch(error => {
        console.log(error)
        return {}
      })
  },
  /**
   * Gets the labor data for the day
   * {"labor":[{"location_id":3,"hours":4.82,"amount":72.27,"employee_id":6132,"starttime":"2019-11-13 09:16:00","endtime":null,"job_id":181,"employeenumber":1134278443336615903,"employeename":"Fierro, Darwin","jobtype":"Cook","clocked_in":1,"shiftstart":"LUNCH","shiftend":null},{"location_id":3,"hours":1.98,"amount":0,"employee_id":6312,"starttime":"2019-11-13 12:06:00","endtime":null,"job_id":402,"employeenumber":1134278443170112479,"employeename":"1111, Employee","jobtype":"Ghost Bartender","clocked_in":1,"shiftstart":"LUNCH","shiftend":null},{"location_id":3,"hours":2.53,"amount":32.95,"employee_id":50132,"starttime":"2019-11-13 11:33:00","endtime":null,"job_id":191,"employeenumber":1537690005749324570,"employeename":"Castaneda, Jorge","jobtype":"Dish","clocked_in":1,"shiftstart":"LUNCH","shiftend":null},{"location_id":3,"hours":0.45,"amount":2.89,"employee_id":55103,"starttime":"2019-11-13 13:38:00","endtime":null,"job_id":171,"employeenumber":1648785527616269316,"employeename":"Skilnik, Dylan","jobtype":"Bartender","clocked_in":1,"shiftstart":"LUNCH","shiftend":null},{"location_id":3,"hours":4.78,"amount":69.38,"employee_id":55439,"starttime":"2019-11-13 09:18:00","endtime":null,"job_id":181,"employeenumber":1667070839493806855,"employeename":"Jesus, Mendoza","jobtype":"Cook","clocked_in":1,"shiftstart":"LUNCH","shiftend":null}],"updated":{"location_id":3,"businessdate":"2019-11-13","lastupdate":"2019-11-13 14:05:05"},"lastupdate":1573679105000,"location":{"name":"El Hefe Chicago","id":3}}
   * @param {int} locationId
   */
  getLocationLabor (locationId, startDate, endDate) {
    return EfishDataService.getData(`api/v1/report/live/location/${locationId}/labor`, null, 'get', moment().add(5, 'Minutes').toDate())
      .then(data => {
        return { timeoff: data.timeoff, exceptions: data.exceptions, clockedin: data.labor.clocked_in, clockedout: data.labor.clocked_out, upcoming: data.labor.upcoming, noshow: data.labor.noshow, hasSchedule: data.hasSchedule }
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getLocationOpenTickets (locationId) {
    return EfishDataService.getData(`api/v1/report/live/location/${locationId}/opentickets`, null, 'get', moment().add(5, 'Minutes').toDate())
      .then(data => {
        return data
      })
      .catch(error => {
        console.log(error)
        return {}
      })
  },
  /**
   * Addes the "needed" (schedule goal) keys to the clocked in reports, and an overall
   * on the location level
   * @param {Object} loc retrieved from /locations or /location/ID
   */
  reportModuleSetLocationGoalData (loc) {
    if (
      loc.lasthour !== false &&
      loc.schedule !== undefined &&
      loc.clocked !== undefined
    ) {
      let needed = 0
      // set a needed on the clocked in object for easy access
      for (var key in loc.schedule) {
        if (Object.prototype.hasOwnProperty.call(loc.clocked, key)) {
          if (loc.schedule[key].functionname === 'salesPerHour') {
            loc.clocked[key].needed =
              Math.ceil(
                loc.lasthour.lasthour_sales / loc.schedule[key].formulametric
              ) * loc.schedule[key].formulavalue
            needed += loc.clocked[key].needed
          } else {
            loc.clocked[key].needed =
              Math.ceil(
                loc.lasthour.lasthour_checks / loc.schedule[key].formulametric
              ) * loc.schedule[key].formulavalue
            if (loc.clocked !== undefined && loc.clocked[key] !== undefined) {
              loc.schedule[key].needed -= loc.clocked[key].count
            }
            // overall summary of total needed employees
            needed += loc.clocked[key].needed
          }
        }
      }
      loc.needed = needed
    } else {
      loc.needed = 0
    }
    // return loc
  }
}

export default LiveReportService
